import Dashboard from './users/New/Dashboard';
import AnalysisPage from './AnalysisPage';
import PBIAnalysisPage from './PBIAnalysisPage';
import Organization from './Organization';
import FoodMenu from './FoodMenu';
import SettingPage from './SettingPage';

import UserListPage from './users/UserListPage';
import CreateUser from './users/CreateUser';
import PersonalInfo from './users/PersonalInfo';
import PermissionSetting from './users/PermissionSetting';

const routes = [
  {
    path: '/',
    component: Dashboard,
    exact: true
  },
  {
    path: '/Analysis/pos',
    component: AnalysisPage
  },
  {
    path: '/Analysis/line',
    component: AnalysisPage
  },
  {
    path: '/Analysis/report',
    component: AnalysisPage
  },
  {
    path: '/Analysis/rfm',
    component: AnalysisPage
  },
  {
    path: '/Analysis/furniture',
    component: AnalysisPage
  },
  {
    path: '/Analysis/supplier',
    component: PBIAnalysisPage
  },
  {
    path: '/Organization',
    component: Organization
  },
  {
    path: '/FoodMenu',
    component: FoodMenu
  },
  {
    path: '/SettingPage',
    component: SettingPage
  },
  {
    path: '/Users/UserList',
    component: UserListPage
  },
  {
    path: '/Users/CreateUser',
    component: CreateUser
  },
  {
    path: '/Users/PersonalInfo',
    component: PersonalInfo
  },
  {
    path: '/Users/PermissionSetting',
    component: PermissionSetting
  }
];

export default routes;